<script>
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";

// Custom Components
import AccountService from "@/helpers/APIService/account.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Account Component

export default {
  page: {
    title: "Sub Accounts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  props: {
    currentProps: Object,
  },
  components: {},
  data() {
    return {
      title: "Sub Accounts",
      table: {
        tableData: [],
        next: null,
        previous: null,
        count: 10,
        total_pages: 1,
        page_number: 1,
        per_page: 10,
        from: 1,
        to: 10,
      },
      submitted: false,
      is_data_loading: true,
      isLoading: true,
      addAccountModel: false,
      selectedCompany: null,
      isEdit: false,
      is_btn_loading: false,
      account: {
        name: "",
        is_display: true,
        id: "",
        index: 0,
        method: "",
      },
      createError: false,
      errorMessage: null,
    };
  },
  validations: {
    account: {
      name: { required },
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    if (this.currentProps !== null) {
      this.account.method = this.currentProps.selectedPaymentMethod.id;
      this.getPaymentAccountBrifList();
    }
  },
  methods: {
    async getPaymentAccountBrifList() {
      if (this.currentProps !== null) {
        this.$root.$on("AddNewPaymentMethod", (data) => {
          this.account.method = data;
          this.$refs["add-account-modal"].show();
        });
        await AccountService.getPaymentAccountBrifList(this.account.method)
          .then((account) => {
            this.table.tableData = account;
          })
          .catch((error) => {
            errorHandler(error);
            this.is_btn_loading = false;
            this.createError = true;

            if (typeof error.response.data.non_field_errors == "object") {
              this.errorMessage = error.response.data.non_field_errors;
            } else {
              this.errorMessage = error.response.data;
            }
          });
        this.isLoading = false;
        this.is_data_loading = false;
      }
    },
    accountModel() {
      this.addAccountModel = !this.addAccountModel;
      this.$refs["add-account-modal"].show();
    },
    accountAddedUpdated() {
      this.is_btn_loading = true;
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        if (this.isEdit == true) {
          let accountData = new FormData();
          accountData.append("name", this.account.name);
          accountData.append("payment_method", this.account.method);
          AccountService.editAccount(
            this.account.method,
            this.account.id,
            accountData
          )
            .then((response) => {
              this.table.tableData[this.account.index] = response;
              Middleware.notification("Successfully updated !!", "success");

              this.submitted = false;
              this.is_btn_loading = false;
              this.isEdit == false;
              this.$refs["add-account-modal"].hide();
            })
            .catch((error) => {
              errorHandler(error);
              this.is_btn_loading = false;
              this.createError = true;
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          let accountData = new FormData();
          accountData.append("hotel", this.hotel.id);
          accountData.append("name", this.account.name);
          accountData.append("payment_method", this.account.method);
          AccountService.addAccount(this.account.method, accountData)
            .then((account) => {
              this.table.tableData.push(account);
              this.is_btn_loading = false;
              this.submitted = false;
              this.$refs["add-account-modal"].hide();
              Middleware.notification("Successfully added !!", "success");

              this.resetModal();
            })
            .catch((error) => {
              this.is_btn_loading = false;
              this.createError = true;
              errorHandler(error);
              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },
    async edit(data, index) {
      this.account.name = data.name;
      this.account.index = index;
      this.account.id = data.id;
      this.isEdit = true;
      this.$refs["add-account-modal"].show();
    },
    changePaymentACStatus(id, status) {
      let accountData = new FormData();
      accountData.append("is_active", status);
      accountData.append("payment_method", this.account.method);
      AccountService.editAccount(this.account.method, id, accountData)
        .then(() => {
          Middleware.notification("Successfully changde status !!", "success");

          this.is_btn_loading = false;
          this.isEdit == false;
          this.$refs["add-account-modal"].hide();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    deleteAccount(account_id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          AccountService.deleteAccount(this.account.method, account_id).then(
            () => {
              this.table.tableData.splice(index, 1);
              // this.getDepartments();
              Middleware.notification("Successfully deleted !!", "danger");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    resetModal() {
      this.isEdit = false;
      this.submitted = false;
      this.is_btn_loading = false;
      this.account.name = "";
      this.account.is_display = true;
      this.account.id = "";
      this.account.index = 0;
    },
    cancelSubmit() {
      this.$refs["add-account-modal"].hide();
      this.resetModal();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-lg-12">
      <!-- Table -->
      <div class="table-responsive mb-0">
        <table class="table table-hover mb-0" ref="my-table">
          <thead class="table-light">
            <tr>
              <th>Name</th>
              <th>Debit</th>
              <th>Credit</th>
              <!-- <th>Invoice</th>
              <th>Payment</th> -->
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody
            id="infinite-list"
            v-if="table.tableData.length > 0 && !is_data_loading"
          >
            <tr v-for="(data, index) in table.tableData" :key="index">
              <td @click="edit(data, index)">
                {{ data.name }}
              </td>
              <td @click="edit(data, index)">
                {{ data.debit_total }}
              </td>
              <td @click="edit(data, index)">
                {{ data.credit_total }}
              </td>
              <!-- <td></td>
              <td></td> -->
              <td>
                <div class="form-check form-switch my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="data.is_active"
                    @change="changePaymentACStatus(data.id, data.is_active)"
                  />
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i
                    v-if="data.is_deleted"
                    class="fas fa-pencil-alt mx-1 text-success fs-5"
                    v-b-popover.hover="'Update recored'"
                    id="edit"
                    @click="edit(data, index)"
                  ></i>
                  <i
                    v-if="data.is_deleted"
                    class="mdi mdi-trash-can mx-1 fs-5 text-danger"
                    v-b-popover.hover="'Delete recored'"
                    id="delete"
                    @click="deleteAccount(data.id, index)"
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
          <!-- Loading areas -->
          <tbody v-if="is_data_loading">
            <tr v-for="number in 4" :key="number">
              <td class="placeholder-glow" v-for="no in 5" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <!-- Empty data image loader -->
          <tbody v-if="!is_data_loading && table.tableData.length == 0">
            <tr>
              <td colspan="8" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Model is for payment account -->
    <b-modal
      ref="add-account-modal"
      @close="resetModal"
      @hidden="resetModal"
      hideFooter
      centered
      :title="!isEdit ? 'Add Payment Account' : 'Update Payment Account'"
    >
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Account" label-for="email-input" class="mb-3">
            <template slot="label">
              Name <span class="text-danger">*</span>
            </template>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              v-model="account.name"
              required
              :class="{
                'is-invalid': submitted && $v.account.name.$error,
              }"
            />
            <div v-if="$v.account.name.$error" class="invalid-feedback">
              <span v-if="!$v.account.name.required">Name is required.</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <h4 v-if="createError">
            <template v-if="typeof errorMessage == 'object'">
              <span v-for="error in errorMessage" :key="error">
                <span class="badge card-badge badge-soft-danger">
                  <b>{{ error }}</b>
                </span>
                <br />
              </span>
            </template>
            <template v-else>
              <span class="badge card-badge badge-soft-danger">
                <b>{{ errorMessage }}</b>
              </span>
            </template>
          </h4>
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
            >Cancel</b-button
          >
          <b-button
            variant="outline-primary"
            class="float-end"
            @click="accountAddedUpdated"
            :class="{
              disabled: is_btn_loading,
            }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle"
              v-if="is_btn_loading"
            ></i>
            {{ isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
